import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {shareReplay} from "rxjs/operators";
import {environment} from '../../env';
import {HttpClient, HttpParams} from "@angular/common/http";
import {CatalogSearchResponse} from "../../models/catalog";

export interface CatalogCategory {
  key: string;
  name_de: string;
}

export interface CatalogProductKind {
  key: string;
  display_name: string;
}

@Injectable({
  providedIn: 'root'
})
export class CatalogService {

  private categories$: Observable<CatalogCategory[]> | null = null;
  private productKinds$: Observable<CatalogProductKind[]> | null = null;

  constructor(private http: HttpClient) {
  }

  searchCatalogProduct(query: string, providers: string[] = [], limit: number = 10): Observable<CatalogSearchResponse> {
    let params = new HttpParams().set('query', query);

    if (providers.length > 0) {
      params = params.set('providers', providers.join(','));
      params = params.set('limit', limit);
    }

    return this.http.get<CatalogSearchResponse>(`${environment.apiUrl}/catalog/search`, {params});
  }

  /** Fetches catalog categories (lightweight reference data, cached). */
  getCategories(): Observable<CatalogCategory[]> {
    if (!this.categories$) {
      this.categories$ = this.http
        .get<CatalogCategory[]>(`${environment.apiUrl}/catalog/categories`)
        .pipe(shareReplay(1));
    }
    return this.categories$;
  }

  /** Fetches catalog product kinds (lightweight reference data, cached). */
  getProductKinds(): Observable<CatalogProductKind[]> {
    if (!this.productKinds$) {
      this.productKinds$ = this.http
        .get<CatalogProductKind[]>(`${environment.apiUrl}/catalog/product-kinds`)
        .pipe(shareReplay(1));
    }
    return this.productKinds$;
  }
}
